import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rw7e9s2ce: FaireProductEntity = {
  token: "p_7rw7e9s2ce",
  type: "product",
  name: "Gimme Seaweed Snacks - Seaweed & Avocado, 12-Pack",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/b07b4105f65af218a71ad7aa5b4c61cc64d503d98f0db2c898e19aa36196e772.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53811a9c9b74d43cc587e5f4ab6d32b02abbd9b3da134edb1b698f70479b5308.jpeg",
    "https://cdn.faire.com/fastly/86df30e107b4e9acaca2728c581b37e914174cf1b9371362bc03825cab80eec6.jpeg",
  ],
  priceDollars: 40.18,
  description:
    "USDA Organic. Certified Organic by: Quality Assurance International, Inc. Certified Gluten-free. Certified Vegan. vegan.org. Non GMO Project verified. nongmoproject.org. No. 1 organic seaweed brand. gimMe was the first to bring the world organic, non-GMO branded seaweed. Ready for something new? gimMe harvests and curates the highest quality, best tasting seaweed on this precious planet. Enjoy gimMe's Roasted Seaweed Snacks and prepare for an umami adventure. Enjoy! - Annie & Steve, gimMe founders. gimmesnacks.com. Facebook (at)gimmeseaweed. Instagram (at)gimmegrams. Learn more at gimmesnacks.com. Sea Turtle Conservancy. We support sea turtles. Product of Korea.",
  tags: [],
  msrpDollars: 63.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:40.912Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
